import { create } from "zustand";

interface CapsuleTagsState {
  dataAllCapsuleTags: string[] | undefined; // Estado inicial para los tags como un array de strings
  setDataAllCapsuleTags: (tags: string[]) => void; // Método para actualizar los tags
}

const useCapsuleTagsStore = create<CapsuleTagsState>((set) => ({
  dataAllCapsuleTags: undefined, // Estado inicial
  setDataAllCapsuleTags: (tags) => set({ dataAllCapsuleTags: tags }), // Método para actualizar
}));

export default useCapsuleTagsStore;
